<template>
    <spinner-until :condition="participantLoaded">
        <participant-menu>
            <div class="my-notes">
                <b-row>
                    <b-col cols="12" ref="my-notes">
                        <b-card no-body>
                            <b-card-header v-if="!showParticipantMenuAsAccordion">
                                <h5>
                                <span class="icon-wrapper icon-wrapper-left">
                                    <shs-icon name="sun"></shs-icon>
                                </span>
                                    {{ $i18n.gt('HEADING_MY_NOTES') }}
                                    <print-button content="my-notes" :refs="$refs"/>
                                </h5>
                            </b-card-header>
                            <b-card-body class="light-bg">
                                <b-row>
                                    <notes-to-self/>
                                </b-row>
                            </b-card-body>
                        </b-card>
                    </b-col>
                </b-row>
            </div>
        </participant-menu>
    </spinner-until>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'
import PatientPageMixin from '@/providers/PatientPageMixin'
import NotesToSelf from "../components/NotesToSelf";

/**
 * Page to manage a Participant's Notes to Self
 */
export default Vue.extend({
    name: 'MyNotes',
    mixins: [PatientPageMixin],
})
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">
.my-notes {
    .print-button {
        float: right;
        margin-top: .2em;
    }
}
</style>
